<template>
  <div class="dropdown">
    <b-form-input
      v-model="param.text"
      list="select-list-id"
      @keyup="updateResult(param.text)"
      class="dropdown-toggle"
      type="button"
      id="dropdownMenuButton"
      data-mdb-toggle="dropdown"
      @click="openDropDown"
      autocomplete="off"
      aria-expanded="false"
      v-click-outside="closeDropDown">
    </b-form-input>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <li
        class="dropdown-item"
        v-for="option in param?.options"
        :key="option.id"
        href="#"
        @click="optionClicked(param, option)">
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    optionClicked(param, option) {
      param.text = option.text;
      param.value = option.value;
      this.openDropDown();
    },
    closeDropDown() {
      var dropdown = document.querySelector(".dropdown");
      dropdown.classList.remove("open");
    },
    openDropDown() {
      var dropdown = document.querySelector(".dropdown");
      dropdown.classList.add("open");
    },
    updateResult(value){
      this.openDropDown()
      this.$emit('updateListResult',value)
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown.open .dropdown-menu {
  display: block;
}
</style>
